import { Star, ExternalLink } from "lucide-react";
import { useI18n } from "../lib/i18n.jsx";
import { useReviews } from "../lib/useReviews.js";

export default function StickyReviewBadge() {
  const { lang } = useI18n();
  const { live, rating, ratingCount, mapsUri } = useReviews();

  if (!live) return null;

  const ratingStr = Number(rating).toFixed(1);
  const reviewsLabel = { pl: "opinii", uk: "відгуків", en: "reviews" }[lang] || "reviews";

  return (
    <a
      href={mapsUri}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="sticky-review-badge"
      aria-label={`${ratingStr} stars on Google, ${ratingCount} reviews`}
      className="fixed z-30 bottom-[84px] right-3 md:bottom-6 md:right-6
                 group flex items-center gap-2
                 bg-white border border-winter/15 rounded-full
                 pl-2.5 pr-3 py-2 md:pl-3 md:pr-4 md:py-2.5
                 shadow-lg shadow-winter/15 hover:shadow-xl
                 hover:bg-cream transition-all duration-200
                 hover:-translate-y-0.5"
    >
      <div className="flex items-center gap-0.5 shrink-0">
        <Star className="w-3.5 h-3.5 md:w-4 md:h-4 fill-sun text-sun" />
      </div>
      <span className="font-display font-bold text-winter text-sm md:text-[15px] leading-none">
        {ratingStr}
      </span>
      <span className="text-winter/40 text-xs leading-none">·</span>
      <span className="font-semibold text-winter/75 text-xs md:text-sm leading-none whitespace-nowrap">
        {ratingCount}
        <span className="hidden md:inline"> {reviewsLabel}</span>
        <span className="font-normal text-winter/50"> Google</span>
      </span>
      <ExternalLink className="hidden md:inline-block w-3.5 h-3.5 text-winter/40 group-hover:text-winter/70 transition-colors shrink-0" />
    </a>
  );
}
